import Model, { belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class AdvancedReportModel extends Model {
  @belongsTo('advanced-report-configuration', {
    inverse: null,
    async: false,
  })
  advancedReportConfiguration!: ModelRegistry['advanced-report-configuration'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'advanced-report': AdvancedReportModel;
  }
}
